export const Bio = {
  name: "Aniket Patidar",
  roles: [
    "Full Stack Developer",
    "Frontend Developer",
    "Backend Developer",
    "Programmer",
    "Freelancer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Aniket-Patidar",
  resume:
    "https://drive.google.com/file/d/1jMCgyo8FjiFXCGLMIUg53SftVHj31V6g/view",
  linkedin: "https://www.linkedin.com/in/aniket-patidar-0b921b219/",
  insta: "https://www.instagram.com/_mr_aniket_patidar/",
  twitter: "",
  facebook: "",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://imgs.search.brave.com/Nxfdh3LF-v-uT2swp6jMDSP24lh15FssWktw5JRsZcI/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9zdGF0/aWMtMDAuaWNvbmR1/Y2suY29tL2Fzc2V0/cy4wMC90YWlsd2lu/ZC1jc3MtaWNvbi0x/MDI0eDYxNS1mZGVp/czVyMS5wbmc",
      },
      {
        name: "React Native",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "TRPC",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLuEXUkQ29MEdfl08hU8OktLHV8QDG-LR2hg&s",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image:
          "./skills/typescript.png",
      },
      {
        name: "C++",
        image:
          "./skills/c-.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git & GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: "./skills/postman.svg"
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://img.freepik.com/free-vector/city-skyline-concept-illustration_114360-8923.jpg?t=st=1719248020~exp=1719251620~hmac=2c1d03e273a2ce98f5e84868e02c7ce2a230ec787928a38a2987e8c4cbeff110&w=1060",
    role: "Fullstack Web Developer",
    company: "Flipr Inovations Pvt. Ltd.",
    date: "Apr 2023 - Persent",
    desc: "Working on Igrow My Biz, managing full stack website and deployment of projects.",
    skills: [
      "Next.js",
      "TRPC",
      "Recat",
      "Tailwind CSS",
      "VPS",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node.js",
      "Express.js",
    ],
    doc: "https://img.freepik.com/free-vector/city-skyline-concept-illustration_114360-8923.jpg?t=st=1719248020~exp=1719251620~hmac=2c1d03e273a2ce98f5e84868e02c7ce2a230ec787928a38a2987e8c4cbeff110&w=1060",
  },
  {
    id: 1,
    img: "https://img.freepik.com/free-vector/city-skyline-concept-illustration_114360-8923.jpg?t=st=1719248020~exp=1719251620~hmac=2c1d03e273a2ce98f5e84868e02c7ce2a230ec787928a38a2987e8c4cbeff110&w=1060",
    role: "Fullstack Web Developer Intern",
    company: "INEXT~ETS.",
    date: "Feb 2024 - Apr 2023",
    desc: "Working on InextETS, managing full stack website and deployment of projects.",
    skills: [
      "Next.js",
      "Recat",
      "Tailwind CSS",
      "VPS",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node.js",
      "Express.js",
    ],
    doc: "https://img.freepik.com/free-vector/city-skyline-concept-illustration_114360-8923.jpg?t=st=1719248020~exp=1719251620~hmac=2c1d03e273a2ce98f5e84868e02c7ce2a230ec787928a38a2987e8c4cbeff110&w=1060",
  },
];

export const education = [
  {
    id: 0,
    img: "https://img.freepik.com/free-vector/vector-cartoon-illustration-school-building-green-lawn-road-trees-educalion-l_134830-1588.jpg?t=st=1719247666~exp=1719251266~hmac=eacfe2fb7c3ab445981159406fe9eef5fa286624fff4f9d5abf67d3a066a20d2&w=1380",
    school: "Sagar Institute of Research & Technology, Bhopal",
    date: "2024 - 2026",
    grade: "N.A",
    desc: "I am Pursuing Master in Computer Applications at Sagar Institute of Research & Technology, Bhopal. I have taken courses in Computer Programming, Software Engineering, Database Management Systems, Web Development, and Computer Networks. I have also participated in various college events and tech fests, and have been an active member of the college coding club.",
    degree: "Master of Computer Applications - MCA",
  },
  {
    id: 1,
    img: "https://img.freepik.com/free-vector/vector-cartoon-illustration-school-building-green-lawn-road-trees-educalion-l_134830-1588.jpg?t=st=1719247666~exp=1719251266~hmac=eacfe2fb7c3ab445981159406fe9eef5fa286624fff4f9d5abf67d3a066a20d2&w=1380",
    school: "Sanskar Green Valley School",
    date: "Completed in 2021",
    grade: "82%",
    desc: "I completed my Class 12 at Sanskar Green Valley School with a percentage of 82% under the CBSE curriculum. My subjects included Physics, Chemistry, Mathematics, and Computer Science. I actively participated in various school events and was a member of the school's science club.",
    degree: "Class 12 - CBSE",
  },
  {
    id: 2,
    img: "https://img.freepik.com/free-vector/vector-cartoon-illustration-school-building-green-lawn-road-trees-educalion-l_134830-1588.jpg?t=st=1719247666~exp=1719251266~hmac=eacfe2fb7c3ab445981159406fe9eef5fa286624fff4f9d5abf67d3a066a20d2&w=1380",
    school: "Sanskar Green Valley School",
    date: "Completed in 2019",
    grade: "65%",
    desc: "I completed my Class 10 at Sanskar Green Valley School with a percentage of 65% under the CBSE curriculum. During my time in school, I was involved in various extracurricular activities and participated in inter-school competitions.",
    degree: "Class 10 - CBSE",
  }
];

export const projects = [
  {
    id: 7,
    title: "Get Tala",
    description: "Created an interactive web experience using GSAP, ScrollTrigger, HTML, CSS, and JavaScript, featuring smooth scroll-triggered animations. This project showcases dynamic content that responds to user interactions seamlessly.",
    image: "./projects/getTala.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Scroll Trigger",
      "Gsap",
    ],
    category: "web app",
    github: "https://github.com/Aniket-Patidar/get-tala-animation",
    webapp: "https://get-tala-animation.vercel.app",
  },
  {
    id: 5,
    title: "Eurotechxchange",
    description: "Worked as a Full Stack Developer on a car exchange platform using the T3 stack for a client based in Dubai. Developed features that enhance the efficiency of car exchanges and designed user-friendly interfaces to improve the overall user experience.",
    image: "./projects/etx.png",
    tags: [
      "Next.js",
      "TypeScript",
      "TRPC",
      "Prisma",
      "Tailwind CSS",
    ],
    category: "web app",
    github: "https://eurotechxchange.com/",
    webapp: "https://eurotechxchange.com/",
  },
  {
    id: 0,
    title: "Gym Web Site",
    description: "Gym Web Site is a sleek and modern web application designed for fitness enthusiasts and gym owners. It offers a user-friendly platform to explore various workout plans, book classes, and track progress. Built with Next.js and Tailwind CSS, the website ensures a seamless and responsive experience across devices. The integration of JavaScript enhances interactivity and performance, making it a robust solution for all your fitness needs.",
    image: "./projects/Gym.png",
    tags: [
      "Next.js",
      "Tailwind CSS",
      "JavaScript",
    ],
    category: "web app",
    github: "https://github.com/Aniket-Patidar/C-Frontend-Gym-main",
    webapp: "https://fitness-icon-gym-website.vercel.app/",
  },
  {
    id: 2,
    title: "Electric Scooter",
    description: "Electric Scooter is an innovative web application tailored for electric scooter rentals. It provides a streamlined interface for users to locate, rent, and manage electric scooters effortlessly. Developed using Next.js and Tailwind CSS, the app offers a fast and visually appealing user experience. JavaScript integration ensures smooth navigation and real-time updates, making it an ideal choice for urban mobility solutions.",
    image: "./projects/scoter.png",
    tags: [
      "Next.js",
      "Tailwind CSS",
      "JavaScript",
    ],
    category: "web app",
    github: "https://github.com/Aniket-Patidar/-scooter",
    webapp: "https://car-rental-website-kohl.vercel.app/",
  },
  {
    id: 3,
    title: "Job Portal",
    description: "Job Portal is a comprehensive web application designed to connect job seekers with employers. It features a powerful search engine, user-friendly interface, and secure login system to facilitate job applications and recruitment processes. Built with the MERN stack (MongoDB, Express.js, React.js, Node.js), it leverages Next.js and Tailwind CSS for a dynamic and responsive design, while JavaScript enhances functionality.",
    image: "./projects/job.png",
    tags: [
      "Next.js",
      "Tailwind CSS",
      "JavaScript",
      "Nodejs",
      "MongoDB",
      "MERN Stack"
    ],
    category: "web app",
    github: "https://github.com/Aniket-Patidar/Satisfide-Frontend-Job",
    webapp: "https://satisfiedjob.com/",
  },
  {
    id: 4,
    title: "Ecommerce Website",
    description: "Ecommerce Website is a sophisticated web application for online shopping, providing a seamless and secure platform for customers to browse and purchase products. It features advanced functionalities like product search, user authentication, and payment processing. The site is built using the MERN stack, with additional support from TypeScript and REST APIs, ensuring a robust and scalable solution. Next.js and Tailwind CSS deliver a modern and responsive user interface.",
    image: "./projects/pachmari.png",
    tags: [
      "Next.js",
      "Tailwind CSS",
      "JavaScript",
      "Nodejs",
      "MongoDB",
      "MERN Stack",
      "TypeScript",
      "Rest Api"
    ],
    category: "web app",
    github: "https://github.com/aniketpatidar123/backend-pachmai",
    webapp: "https://pachmani-next.vercel.app/",
  },
  {
    id: 6,
    title: "Job Portal",
    description: "Job Portal is a comprehensive android application designed to connect job seekers with employers. It features a powerful search engine, user-friendly interface, and secure login system to facilitate job applications and recruitment processes. Built with the MERN stack (MongoDB, Express.js, React.js, Node.js), it leverages Next.js and Tailwind CSS for a dynamic and responsive design, while JavaScript enhances functionality.",
    image: "./projects/satisfied-app.png",
    tags: [
      "React Native",
      "Tailwind CSS",
      "JavaScript",
      "Nodejs",
      "MongoDB",
      "MERN Stack",
      "TypeScript",
      "Rest Api"
    ],
    category: "android app",
    github: "https://play.google.com/store/apps/details?id=com.aniketpatidar.SatisfiedJobs&pcampaignid=web_share",
    webapp: "https://play.google.com/store/apps/details?id=com.aniketpatidar.SatisfiedJobs&pcampaignid=web_share",
  },
  {
    id: 7,
    title: "Fanta",
    description: "Redesigned the Fanta website with a fresh, vibrant UI using HTML, CSS, JavaScript, ScrollTrigger, and GSAP. The site features engaging animations and interactive elements that enhance the user experience as they explore the brand.",
    image: "./projects/fanta.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Scroll Trigger",
      "Gsap",
    ],
    category: "web app",
    github: "https://fanta-mu.vercel.app/",
    webapp: "https://fanta-mu.vercel.app/",
  },
];



export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
